import { render, staticRenderFns } from "./doctorAlertBanner.vue?vue&type=template&id=475a9176&"
import script from "./doctorAlertBanner.vue?vue&type=script&lang=js&"
export * from "./doctorAlertBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports